import { HttpMethod, Performer } from '../core'

export class GameStart extends Performer<void, boolean> {
  protected method = HttpMethod.POST
  protected url = '/game-start'
}
